import React from 'react'
import {Button, Panel} from 'react-bootstrap'
import HelpPopover from '../../../../../shared/javascripts/components/HelpPopover'
import { helpText } from '../../constants'

export default class ServerPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'hard_drive',
      'cron_status',
      'mongo_status'
    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'hard_drive':
        if(data.hard_disk_space<=10) {
          return 'danger'
        }else if(data.hard_disk_space<=20) {
          return 'warning'
        }else {
          return
        }
      case 'cron_status':
        if(data.cron_status==='inactive') {
          return 'danger'
        }else {
          return
        }
      case 'mongo_status':
        if(data.mongo_status==='inactive') {
          return 'danger'
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              SERVER
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.hard_drive}`}>
                  Hard Drive <HelpPopover helpText={helpText.hard_drive} />
                </dt>
                <dd className={`text-${errorOrWarning.hard_drive}`}>{data.hard_disk_space}%</dd>

                <dt className={`text-${errorOrWarning.cron_status}`}>Cron Jobs Service <HelpPopover helpText={helpText.cron_job} /></dt>
                <dd className={`text-${errorOrWarning.cron_status}`}><span className={`label ${(data.cron_status==='active' ? 'label-success' : 'label-danger')}`}>{data.cron_status}</span></dd>

                <dt className={`text-${errorOrWarning.mongo_status}`}>Mongo DB Service <HelpPopover helpText={helpText.mongo_service} /></dt>
                <dd className={`text-${errorOrWarning.mongo_status}`}><span className={`label ${(data.mongo_status==='active' ? 'label-success' : 'label-danger')}`}>{data.mongo_status}</span></dd>
              </dl>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Dataquest/ServerPanel.jsx